import Vue from "vue";
import Vuex from "vuex";

/* Modules */
import config from "./modules/config";
import works from "./modules/works";
import workPlaceAssocs from './modules/workPlaceAssocs';
import users from "./modules/users";
import employments from "./modules/employments";
import foodEmployments from "./modules/foodEmployments";
import places from "./modules/places";
import foodLicenses from "./modules/foodLicenses";
import foodAcs from "./modules/foodAcs";
import foodProducts from "./modules/foodProducts";
import foodCategories from "./modules/foodCategories";
import foodRooms from './modules/foodRooms';
import foodTables from './modules/foodTables';
import foodOrders from "./modules/foodOrders";
import foodOrderElements from "./modules/foodOrderElements";
import foodPayments from './modules/foodPayments';
import foodPrinters from "./modules/foodPrinters";
import foodInventoryLogs from "./modules/foodInventoryLogs";
import foodInventoryLogEntries from "./modules/foodInventoryLogEntries";
import ybLicenses from './modules/ybLicenses';
import documentSeries from './modules/documentSeries';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config,
    works,
    workPlaceAssocs,
    users,
    employments,
    foodEmployments,
    places,
    foodLicenses,
    foodAcs,
    foodProducts,
    foodCategories,
    foodRooms,
    foodTables,
    foodOrders,
    foodOrderElements,
    foodPayments,
    foodPrinters,
    foodInventoryLogs,
    foodInventoryLogEntries,
    ybLicenses,
    documentSeries
  },
  state: {
    lang: 'it',
    work: 0,
    windowWidth: 0,
    windowHeight: 0,
    deviceSpecs: {},
    licenseSelected: null,
    isDownloading: false,
    isSaving: false,
    isPrinterMaster: false
  },
  getters: {
    getWindowWidth: state => {
      return state.windowWidth;
    },
    getWindowHeight: state => {
      return state.windowHeight;
    },
    getLicense: state => {
      return state.licenseSelected;
    }
  },
  mutations: {
    updateLang: (state, lang) => {
      state.lang = lang;
    },
    updateDimensions: (state, { width, height }) => {
      state.windowWidth = width;
      state.windowHeight = height;
    },
    updateDeviceSpecs: (state, specs) => {
      state.deviceSpecs = specs;
    },
    setLicense: (state, license) => {
      state.licenseSelected = license;
    },
    setIsDownloading: (state, val) => {
      state.isDownloading = val;
    },
    setIsSaving: (state, val) => {
      state.isSaving = val;
    },
    setIsPrinterMaster: (state, val) => {
      state.isPrinterMaster = val;
    },
  },
  actions: {
    updateLang: async ({ commit, state }, obj) => {
      commit('updateLang', obj.lang);
      obj.app.$moment.locale(state.lang);
    },
    updateDimensions: async ({ commit }, dimensions) => {
      commit('updateDimensions', dimensions);
    },
    updateDeviceSpecs: async ({ commit }, specs) => {
      commit('updateDeviceSpecs', specs);
    },
    setLicense: async ({ commit }, license) => {
      commit('setLicense', license);
    },
    setIsDownloading: async ({ commit }, val) => {
        commit("setIsDownloading", val);
    },
    setIsSaving: async ({ commit }, val) => {
        commit("setIsSaving", val);
    },
    setIsPrinterMaster: async ({ commit }, val) => {
        commit("setIsPrinterMaster", val);
    },
  }
});
